<template>
  <div>
    <slot name="form"></slot>
    <slot name="searchPanel" v-if="searchPanel">
      <v-expansion-panels accordion v-model="opened" v-if="!vchip">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Pannello di ricerca
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card flat>
              <v-card-title class="text-body1">
                Opzioni di visualizzazione
              </v-card-title>
              <v-card-text>
                <v-row class="align-center">
                  <v-col cols="10" md="4" offset-md="2">
                    <v-text-field
                      v-if="searchType === 'data'"
                      v-model="da"
                      label="Data da"
                      type="date"
                      @input="setDataA"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="searchType === 'mese'"
                      v-model="da"
                      label="Mese da"
                      type="month"
                      @input="setDataA"
                    ></v-text-field>
                    <year-select
                      v-else-if="searchType === 'anno'"
                      v-model="da"
                      label="Anno da"
                      @input="setDataA"
                    ></year-select>
                  </v-col>
                  <v-col cols="10" md="4">
                    <v-text-field
                      v-if="searchType === 'data'"
                      v-model="a"
                      label="Data a"
                      type="date"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="searchType === 'mese'"
                      v-model="a"
                      label="Mese a"
                      type="month"
                    ></v-text-field>
                    <year-select
                      v-else-if="searchType === 'anno'"
                      v-model="a"
                      label="Anno a"
                    ></year-select>
                  </v-col>
                  <v-col cols="2">
                    <v-btn icon @click="updateList">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-chip v-if="vchip" class="ma-2" close @click:close="resetSearch">
        {{ computedFilterLabel }}
      </v-chip>
    </slot>
    <table-toolbar
      v-model="attrs.search"
      :rapidSearch="!hideRapidSearch"
      v-if="toolbar"
    >
      <table-toolbar-button
        v-if="back"
        type="CANCEL"
        @click="cancel"
      ></table-toolbar-button>
      <table-toolbar-button
        v-if="reload"
        type="RELOAD"
        @click="updateList"
      ></table-toolbar-button>
      <slot name="toolbar"></slot>
    </table-toolbar>
    <slot></slot>
    <slot name="table" :attrs="attrs"></slot>
  </div>
</template>

<script>
import { mesi } from "@/constants";
export default {
  name: "sea-page-content",
  props: {
    fetchList: Function,
    resetList: Function,
    hideRapidSearch: { type: Boolean, default: false },
    searchType: { type: String, default: "data" },
    toolbar: { type: Boolean, default: false },
    back: { type: Boolean, default: false },
    reload: { type: Boolean, default: false },
    searchPanel: { type: Boolean, default: false },
  },
  mounted() {
    if (this.fetchList) this.updateList();
  },
  destroyed() {
    if (this.resetList) this.resetList();
  },
  data() {
    return {
      attrs: {
        loading: true,
        footerProps: {
          itemsPerPageAllText: "Tutte",
          itemsPerPageText: "Righe per pagina",
        },
        itemsPerPage: -1,
        mobileBreakpoint: "960",
        search: null,
        class: "mt-2",
      },
      vchip: false,
      opened: null,
      da: null,
      a: null,
    };
  },
  methods: {
    resetSearch() {
      this.da = null;
      this.a = null;
      this.vchip = false;
      this.updateList();
    },
    updateList() {
      const da = this.da ? this.da : "";
      const a = this.a ? this.a : "";
      this.attrs.loading = true;
      this.fetchList({
        da,
        a,
      }).then(() => {
        this.attrs.loading = false;
        if (da || a) this.vchip = true;
      });
    },
    setDataA() {
      if (!this.a) {
        this.a = this.da;
      }
    },
    formatDaA(val) {
      if (this.searchType === "data")
        return this.$options.filters.dateFormat(val);
      else if (this.searchType === "mese") {
        const arr = val.split("-");
        return `${arr[0]}/${mesi[Number(arr[1]) - 1]}`;
      }
      return val;
    },
    cancel() {
      this.$router.back();
    },
  },
  computed: {
    computedFilterLabel() {
      let out = "";
      if (this.da && this.a && this.da === this.a)
        out += `${this.formatDaA(this.da)};`;
      else {
        if (this.da) out += `${this.formatDaA(this.da)};`;
        if (this.a) out += `${this.formatDaA(this.a)};`;
      }
      return out;
    },
  },
};
</script>

<style>
td {
  cursor: pointer;
}
</style>
